/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('TestAPIServiceApi', ($http, ApiErrorService) => {
    return {
        test: test,
        sendTestEmail: sendTestEmail,
        testAuthenticated: testAuthenticated,
        getAllServerControllerStatus: getAllServerControllerStatus,
        getServerControllerStatus: getServerControllerStatus
    };
    function test() {
        return $http.get(`api/TestAPI/Test`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function sendTestEmail(fromAddress, toAddresses, subject, message) {
        return $http.post(`api/TestAPI/Email?fromAddress=${encodeURIComponent(fromAddress)}&toAddresses=${encodeURIComponent(toAddresses)}&subject=${encodeURIComponent(subject)}&message=${encodeURIComponent(message)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testAuthenticated() {
        return $http.get(`api/TestAPI/TestAuthenticated`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllServerControllerStatus() {
        return $http.get(`api/TestAPI/AllServerControllerStatus`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getServerControllerStatus(serverControllerId) {
        return $http.get(`api/TestAPI/ServerControllerStatus?serverControllerId=${serverControllerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
